if (!customElements.get('veise-variant-upc')) {
  customElements.define('veise-variant-upc', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      document.addEventListener('variant:change', (event) => {
        const form = event.target;
        // Ignore recommendation quick-buy forms and other products on the page.
        if (!form?.getAttribute?.('id')?.startsWith(`product-form-${this.dataset.productId}-`) ||
            !form.closest('.veise-pdp-template')) return;
        this.textContent = event.detail?.variant?.barcode || '—';
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

const isCurrentProductEvent = (element, event) => {
  const form = event.target;
  return form?.getAttribute?.('id')?.startsWith(`product-form-${element.dataset.productId}-`) &&
    form.closest('.veise-pdp-template');
};

if (!customElements.get('veise-variant-color')) {
  customElements.define('veise-variant-color', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      document.addEventListener('variant:change', (event) => {
        if (!isCurrentProductEvent(this, event)) return;
        const index = Number.parseInt(this.dataset.optionIndex, 10);
        this.textContent = event.detail?.variant?.options?.[index] || '—';
      }, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

if (!customElements.get('veise-variant-banners')) {
  customElements.define('veise-variant-banners', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      if (!this.hasAttribute('data-option-index')) return;
      document.addEventListener('variant:change', (event) => {
        if (!isCurrentProductEvent(this, event)) return;
        const index = Number.parseInt(this.dataset.optionIndex, 10);
        this.show(event.detail?.variant?.options?.[index]);
      }, { signal: this.controller.signal });
    }

    show(value) {
      for (const group of this.querySelectorAll('[data-variant-value]')) {
        group.hidden = group.dataset.variantValue !== value;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
